import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { type FormikProps } from 'formik';
import dayjs from 'dayjs';
import { type ExtendDeadlineFormikProps } from './types';
import { EXTEND_REG_FEE_DDL } from '../lang';
import { DatePicker } from '../../../../../../components';

type ExtendDeadlineComponentProps = {
  formik: FormikProps<ExtendDeadlineFormikProps>;
};

export const ExtendPaymentDeadlineBox: React.FC<
  ExtendDeadlineComponentProps
> = (props: ExtendDeadlineComponentProps) => {
  const { formik } = props;
  return (
    <>
      <Stack direction={'row'} justifyContent={'space-between'} spacing={8}>
        <Box className="w-full">
          <Typography>
            {EXTEND_REG_FEE_DDL.DIALOG.EXTEND_DDL.COMPONENT.FROM}
          </Typography>
          <DatePicker fullWidth disabled value={formik.values.previousDate} />
        </Box>
        <Box className="w-full">
          <Typography>
            {EXTEND_REG_FEE_DDL.DIALOG.EXTEND_DDL.COMPONENT.TO}
          </Typography>
          <DatePicker
            fullWidth
            name="extendedDate"
            minDate={dayjs()}
            value={formik.values.extendedDate}
            maxDate={dayjs().add(2, 'months')}
            onChange={date => {
              void formik.setFieldValue('extendedDate', date);
            }}
            onBlur={formik.handleBlur}
            error={
              (formik.touched.extendedDate as boolean) &&
              Boolean(formik.errors.extendedDate)
            }
            helperText={
              (formik.touched.extendedDate as boolean) && (
                <>{formik.errors.extendedDate}</>
              )
            }
          />
        </Box>
      </Stack>
    </>
  );
};
